import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-gys-vezne-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';

import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {GysVezneService} from "../ctl-gys-vezne.service";
import {DlistDto} from "@dabnet-kamu/libs/ui";


@Component({
  selector: 'dk-ctl-gys-vezne-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-gys-vezne-arama.component.html',
  styleUrls: ['./ctl-gys-vezne-arama.component.scss'],
})
export class CtlGysVezneAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private gysVezneService:GysVezneService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    // DKM-5066 Clara: eski hâli
    // this.data = this.service.getData(this.control);
    // DKM-5456 Cedric: eski hâli
    // this.data = this.service.getData(this.control, this.gysVezneService.turu);
    this.data = this.service.getData(this.control, this.gysVezneService.turu, this.gysVezneService.tumVezneler);
    this.gridControlsList$ = this.gysVezneService.gridControlsList$;
    this.gysVezneService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

